export enum ArticleMovementType {
  template = "template",
  maintenance = "maintenance",
}
